import React from 'react';
import LoadingSpinner from '../common/LoadingSpinner';
import { relativeTime } from '../../utils/formatters';

// Порядок групп = порядок разбора: сначала то, где уже теряются деньги.
const SEVERITY_GROUPS = [
  { key: 'high', title: 'Срочно' },
  { key: 'medium', title: 'Стоит посмотреть' },
  { key: 'low', title: 'Не горит' },
];

const CODE_LABELS = {
  billing_failed: 'Списание',
  suspended: 'Заблокирована',
  trial_expired: 'Триал истёк',
  trial_expiring: 'Триал кончается',
  cancel_requested: 'Отмена',
  no_logins: 'Нет активности',
  iiko_not_connected: 'iiko',
  ticket_awaiting_reply: 'Поддержка',
  no_https: 'HTTPS',
};

const AttentionCard = ({ data, loading, onOpenOrg }) => {
  const items = data?.items || [];

  return (
    <section className="ui-card">
      <div className="ui-card-head">
        <h2>Требует внимания</h2>
        <p>Организации, с которыми стоит что-то сделать сегодня.</p>
      </div>

      {loading && <LoadingSpinner />}

      {!loading && items.length === 0 && (
        <div className="ui-empty">Всё спокойно — ничего не требует вмешательства</div>
      )}

      {!loading && SEVERITY_GROUPS.map(({ key, title }) => {
        const group = items.filter((item) => item.severity === key);
        if (group.length === 0) return null;

        return (
          <div className="platform-attention-group" key={key}>
            <div className="platform-attention-group-title">
              {title} <span className="ui-dim">· {group.length}</span>
            </div>
            <div className="platform-org-table">
              {group.map((item, index) => (
                <button
                  type="button"
                  className={`platform-attention-row sev-${item.severity}`}
                  key={`${item.org_id}-${item.code}-${index}`}
                  onClick={() => onOpenOrg(item.org_id)}
                >
                  <span className="platform-org-main">
                    <span className="platform-org-name">{item.org_name}</span>
                    <span className="ui-dim">{item.message}</span>
                  </span>
                  <span className="ui-badge">{CODE_LABELS[item.code] || item.code}</span>
                  {item.since && <span className="ui-dim">{relativeTime(item.since)}</span>}
                </button>
              ))}
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default AttentionCard;
